import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';
import { Phone, Linkedin, Mail, PenTool, Sun, Reply, AlertTriangle } from 'lucide-react';

export function SequenceTodayBar() {
  const [d, setD] = useState(null);
  useEffect(() => { api.getSequencesToday().then(r => setD(r.data)).catch(() => {}); }, []);
  if (!d || (!d.active && !d.responses_today)) return null;
  const chips = [
    { n: d.due.call, label: 'calls', Icon: Phone, cls: 'text-amber-300 border-amber-600/40 bg-amber-600/10' },
    { n: d.due.linkedin, label: 'LinkedIn touches', Icon: Linkedin, cls: 'text-sky-300 border-sky-600/40 bg-sky-600/10' },
    { n: d.due.letter, label: 'letters', Icon: PenTool, cls: 'text-violet-300 border-violet-600/40 bg-violet-600/10' },
    { n: d.due.email, label: 'manual emails', Icon: Mail, cls: 'text-rose-300 border-rose-600/40 bg-rose-600/10' },
    { n: d.emails_auto, label: 'emails send automatically', Icon: Mail, cls: 'text-emerald-300 border-emerald-600/40 bg-emerald-600/10' },
  ].filter(c => c.n > 0);
  return (
    <div className="bg-card border border-border rounded-sm px-4 py-3 flex items-center gap-3 flex-wrap" data-testid="sequence-today-bar">
      <span className="flex items-center gap-1.5 text-xs font-medium text-foreground">
        <Sun className="w-3.5 h-3.5 text-amber-400" /> Due today
      </span>
      {chips.length === 0 ? (
        <span className="text-xs text-muted-foreground" data-testid="today-all-clear">
          nothing due — {d.active} sequence{d.active === 1 ? '' : 's'} running on autopilot
        </span>
      ) : chips.map((c, i) => (
        <span key={i} className={`flex items-center gap-1.5 text-[11px] font-mono border rounded-sm px-2 py-1 ${c.cls}`} data-testid={`today-chip-${c.label.split(' ')[0]}`}>
          <c.Icon className="w-3 h-3" /> {c.n} {c.label}
        </span>
      ))}
      {d.overdue > 0 && (
        <span className="flex items-center gap-1 text-[11px] font-mono text-red-300 border border-red-600/40 bg-red-600/10 rounded-sm px-2 py-1" data-testid="today-overdue">
          <AlertTriangle className="w-3 h-3" /> {d.overdue} overdue
        </span>
      )}
      {d.responses_today > 0 && (
        <span className="ml-auto flex items-center gap-1.5 text-[11px] font-medium text-emerald-300 border border-emerald-600/40 bg-emerald-600/10 rounded-sm px-2 py-1 flex-wrap" data-testid="today-responses">
          <Reply className="w-3 h-3" /> {d.responses_today} response{d.responses_today === 1 ? '' : 's'} received today:
          {(d.responded_deals || []).map(p => (
            <Link key={p.id} to={`/projects/${p.id}`} data-testid={`today-response-deal-${p.id}`}
              className="underline underline-offset-2 hover:text-emerald-200 font-semibold">{p.name}</Link>
          ))}
        </span>
      )}
    </div>
  );
}
